<template>
  <exportTemplate ref="exportTemplate" placement="" :formModel="formModel" :formRules="formRules" :table-data="tableList" :summary-data="tableSummaryData" :table-total="paginationTotal" :table-load="tableLoading" @set-custom-columns="setCustomColumns" @close-custom-columns="closeCustomColumns" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @table-export="tableExport" @row-dblclick="rowDblclick">
    <template #form v-if="false">
      <el-form-item label="日期范围" prop="billDate.selected">
        <date-picker style="width: 100%;" v-model="formModel.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"></date-picker>
      </el-form-item>
      <el-form-item label="时间段" prop="billTime.selected">
        <el-time-picker style="width: 100%;" is-range v-model="formModel.billTime.selected" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm:ss">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="仓库" prop="inWarehouse.selected">
        <select-multiple :select-data="formModel.inWarehouse"></select-multiple>
      </el-form-item>
      <el-form-item label="商品" prop="product.selected">
        <el-select class="select_multiple" style="width: 100%;" ref="productSelectRef" v-model="formModel.product.selected" value-key="value" multiple clearable placeholder="请选择商品名称" @focus="productInputFocus" @change="productChange">
          <el-option v-for="item in formModel.product.list" :key="item.value" :label="item.text" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生产日期" prop="productionDate.selected">
        <el-date-picker style="width: 100%;" v-model="formModel.productionDate.selected" type="date" value-format="yyyy-MM-dd" placeholder="请选择生产日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="单据类型" prop="billType.selected">
        <el-select v-model="formModel.billType.selected" placeholder="请选择单据类型" clearable style="width: 100%;">
          <el-option label="采购单" value="CGD" ></el-option>
          <el-option label="采购退货单" value="CGT" ></el-option>
          <el-option label="销售单" value="XSD" ></el-option>
          <el-option label="退货单" value="XST" ></el-option>
          <el-option label="调拨单" value="DBD" ></el-option>
          <el-option label="盘库单" value="PKD" ></el-option>
          <el-option label="费用单" value="FYD" ></el-option>
          <el-option label="红冲单" value="HCD" ></el-option>
        </el-select>
      </el-form-item>
    </template>
    <template>
      <el-table-column label="出库库房" prop="outWarehouseName" v-if="customColumnList['outWarehouseName']" width="150"></el-table-column>
      <el-table-column label="入库库房" prop="inWarehouseName" v-if="customColumnList['inWarehouseName']" width="150"></el-table-column>
      <el-table-column label="制单时间" prop="dateTime" v-if="customColumnList['dateTime']" width="150"></el-table-column>
      <el-table-column label="来源单号" prop="sourceBillNoID" v-if="customColumnList['sourceBillNoID']" width="150"></el-table-column>
      <el-table-column label="单据类型" prop="transType" v-if="customColumnList['transType']" width="100"></el-table-column>
      <el-table-column label="商品" prop="itemName" v-if="customColumnList['itemName']" width="150"></el-table-column>
      <el-table-column label="规格" prop="itemSpec" v-if="customColumnList['itemSpec']" width="100"></el-table-column>
      <el-table-column prop="itemCode" v-if="customColumnList['itemCode']" label="商品编码" width="130" align="center"></el-table-column>
      <el-table-column prop="salBarCode" v-if="customColumnList['salBarCode']" label="大单位条码" width="130" align="center"></el-table-column>
      <el-table-column prop="midBarCode" v-if="customColumnList['midBarCode']" label="中单位条码" width="130" align="center"></el-table-column>
      <el-table-column prop="invBarCode" v-if="customColumnList['invBarCode']" label="小单位条码" width="130" align="center"></el-table-column>
      <el-table-column prop="brandName" v-if="customColumnList['brandName']" label="商品大类" width="100" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="itemTypeName" v-if="customColumnList['itemTypeName']" label="商品小类" width="100" align="center" sortable="custom"></el-table-column>
      <el-table-column label="变动前数量" prop="changeBeforeQty" v-if="customColumnList['changeBeforeQty']" width="120"></el-table-column>
      <el-table-column label="生产日期" prop="productionDate" v-if="customColumnList['productionDate']" width="120"></el-table-column>
      <el-table-column label="变动数量" prop="onhandQtyUnit" v-if="customColumnList['onhandQtyUnit']" width="120"></el-table-column>
      <el-table-column label="变动数量(折算小单位)" prop="changeQtyStr" v-if="customColumnList['changeQtyStr']" width="140"></el-table-column>
      <el-table-column label="剩余数量" prop="surplusQty" v-if="customColumnList['surplusQty']" width="120"></el-table-column>
      <el-table-column label="剩余数量(折算小单位)" prop="surplusQtyStr" v-if="customColumnList['surplusQtyStr']" width="140"></el-table-column>
      <el-table-column label="交易客户" prop="customerName" v-if="customColumnList['customerName']" width="150"></el-table-column>
      <el-table-column label="重量(Kg)" prop="itemWeight" width="100" v-if="customColumnList['itemWeight']"></el-table-column>
      <el-table-column label="重量(吨)" prop="itemWeightTon" width="100" v-if="customColumnList['itemWeightTon']"></el-table-column>
      <el-table-column label="备注" prop="remark" v-if="customColumnList['remark']"  width="100" ></el-table-column>
    </template>
    <el-dialog title="选择商品" :visible.sync="selectProductVisible" width="1080px" append-to-body :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :default-checked-keys="formModel.product.list"></selectProduct>
    </el-dialog>
  </exportTemplate>
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
import selectProduct from '@/components/common/selectProduct.vue'
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getNowFormatDate, getAddDate, getQueryItem, exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate,
    selectProduct,
    datePicker
  },
  data() {
    return {
      pickerOptions,
      params: {
        page: 1,
        isMaster: 'N',
        size: 10,
        beginDate: getAddDate(-3),
        endDate: getNowFormatDate(),
        beginTime: '00:00:00',
        endTime: '23:59:59',
      },
      formModel: {
        billDate: { submitName: 'billDate', selected: [getAddDate(-3), getNowFormatDate()] },
        billTime: { submitName: 'billTime', selected: [ '00:00:00', '23:59:59' ] },
        productionDate: { submitName: 'productionDate', selected: '' },
        inWarehouse: { submitName: 'warehouseID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll:false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择仓库', request: { url: '/Account/wareHouseDefine/selectWarehouseForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        product: { submitName: 'itemID', selected: [], valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择商品名称', request: { url: '/Account/itemMasterDefine/selectItemMastForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: '' }},
        billType: { submitName: 'billType', selected: '' },
      },
      paginationTotal: 0,
      tableLoading: false,
      tableList: [],
      tableSummaryData: {},
      selectProductVisible: false,
      customColumnsList: [{ "label": "出库库房", "prop": "outWarehouseName", "id": 11, "isShow": "Y" }, { "label": "入库库房", "prop": "inWarehouseName", "id": 12, "isShow": "Y" }, { "label": "商品", "prop": "itemName", "id": 4, "isShow": "Y" }, { "label": "规格", "prop": "itemSpec", "id": 5, "isShow": "Y" }, { "label": "商品编码", "prop": "itemCode" }, { "label": "大单位条码", "prop": "salBarCode" }, { "label": "中单位条码", "prop": "midBarCode" }, { "label": "小单位条码", "prop": "invBarCode" }, { "label": "商品大类", "prop": "brandName" }, { "label": "商品小类", "prop": "itemTypeName" }, { "label": "制单时间", "prop": "dateTime", "id": 1, "isShow": "Y" }, { "label": "来源单号", "prop": "sourceBillNoID", "id": 2, "isShow": "Y" }, { "label": "单据类型", "prop": "transType", "id": 3, "isShow": "Y" }, { "label": "变动前数量", "prop": "changeBeforeQty", "id": 6, "isShow": "Y" }, { "label": "生产日期", "prop": "productionDate", "id": 7, "isShow": "Y" }, { "label": "变动数量", "prop": "onhandQtyUnit", "id": 8, "isShow": "Y" }, { "label": "变动数量(折算小单位)", "prop": "changeQtyStr", "id": 9, "isShow": "Y" }, { "label": "剩余数量", "prop": "surplusQty", "id": 10, "isShow": "Y" }, { "label": "剩余数量(折算小单位)", "prop": "surplusQtyStr", "id": 11, "isShow": "Y" }, { "label": "交易客户", "prop": "customerName", "id": 12, "isShow": "Y" }, { "label": "备注", "prop": "remark", "id": 13, "isShow": "Y" }],
      customColumn: [],
      formRules: {
        'inWarehouse.selected': [
          { required: true, message: '请选择仓库', trigger: 'blur' }
        ],
        'product.selected': [
          { required: true, message: '请选择商品', trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    customColumnList() {
      let tempItem = {}
      this.customColumn.forEach(i => {
        tempItem[i.prop] = (i.isShow == 'Y')
      })
      return tempItem
    }
  },
  created() {
    this.getCustomColumnsList()
    // this.getTableList()
  },
  methods: {
    setCustomColumns(el) {
      let tempArr = [...this.customColumn]
      el.loading = false
      el.setCustomcolumns(JSON.parse(JSON.stringify(tempArr)))
    },
    closeCustomColumns(el) {
      el.$nextTick(async () => {
        let { customColumns } = el
        const { data: res } = await this.$http.post('/Account/customerColumnDefineVue/saveColAndAuthByFuncCode.html', this.Qs.stringify({
          funcCode: 427,
          customSetInfo: JSON.stringify(customColumns)
        }))
        if (res.code != 'success') return this.$message.error(res.message)
        this.$message.success(res.message)
        this.$refs.exportTemplate.closeColumn()
        this.getCustomColumnsList()
      })
    },
    productChange(val) {
      this.formModel.product.list = val
    },
    async getCustomColumnsList() {
      const { data: res } = await this.$http.post(
        "Account/dataSearchVue/selectColumnByFuncCode.html",
        this.Qs.stringify({ funcCode: 427 })
      );
      if (res.code != "success") return this.$confirm(res.message, "提示", {
        confirmButtonText: "确定",
        showCancelButton: false,
        type: "error",
      });
      let result = JSON.parse(res.result);
     
      let arr = [];
      this.customColumnsList.forEach((item) => {
         console.log(item);
        result.forEach(($item) => {
          if (item.prop == $item.prop) {
            arr.push({
              id: $item.id,
              label: item.label,
              prop: item.prop,
              isShow: $item.isShow,
            });
          }
        });
      });
      this.customColumn = [...arr]
      this.$nextTick(() => {
        this.$refs.exportTemplate.$refs.table.doLayout()
      })
    },
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...getQueryItem(this.formModel) }
      console.log(this.params)
      this.getTableList()
    },
    formReset() {
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$post(
        "/erpnew/account/c/reada46ceb/invItemMaster/queryInvItemTransSum.html",
        this.params
      )
      this.tableLoading = false
      if (res.code != '0') return this.$message.error(res.message)
      let { data, sum, total } = res.data
      this.paginationTotal = total
      this.tableSummaryData = sum
      this.tableList = data
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    tableExport(tabColumn) {
      let arr = []
      this.customColumnsList.forEach(i => {
        tabColumn.forEach(j => {
          if (i.prop == j.prop) {
            arr.push(j)
          }
        })
      })
      exportExcelCommonForVue(this.params, arr, '/erpnew/account/c/reada46ceb/invItemMaster/queryInvItemTransSumExcelReport.html')
      console.log(arr)
    },
    productInputFocus() {
      this.$refs['productSelectRef'].blur()
      this.selectProductVisible = true
    },
    getProductData(data) {
      this.selectProductVisible = false
      this.formModel.product.selected = data
      this.formModel.product.list = data
    },
    rowDblclick({ row }) {
      console.log(row);
      this.$emit('emitDblclick', row)
      // let options = this.Qs.stringify({
      //   item: { text: row.itemName, value: row.itemID },
      //   warehouse: { text: row.warehouseName, value: row.warehouseID }
      // })
      // let url = `/templates/vue-account/dist/index.htm#/dataSearchStockMainAccountDetailed?${options}`
      // this.$refs.exportTemplate.toJump('库存明细', url)
    }
  }
}
</script>

<style lang="less" scoped>
</style>